<template>
  <div>
    <v-row no-gutters justify="center" align="center">
      <v-icon large color="accent">pan_tool</v-icon>
    </v-row>
    <v-row no-gutters justify="center" align="center" class="pt-4 font-weight-medium">
      Cette fonctionnalité est malheureusement indisponible dans notre formule gratuite
    </v-row>
    <v-row no-gutters justify="center" align="center" class="pt-6">
      <v-btn class="n-small-btn n-primary-btn" @click="generateCrispMessage">
        Je veux pouvoir y accéder
      </v-btn>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: String,
      required: true,
    },
  },

  computed: {
    crispMessage() {
      return `Bonjour, je suis actuellement en formule gratuite et je souhaiterais accéder à "${this.item}", comment faire ?`;
    },
  },

  methods: {
    generateCrispMessage() {
      window.$crisp.push([`do`, `chat:open`]);
      window.$crisp.push([`do`, `message:send`, [`text`, this.crispMessage]]);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
